import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { WettbewerberPreisViewDto } from '../Mza/Service/Controllers/V1/Kunden/Models/wettbewerberpreisviewdto.entity';
//#endregion

@Injectable()
export class WettbewerberPreisViewDtoService extends ODataEntityService<WettbewerberPreisViewDto> {
  constructor(protected client: ODataClient) {
    super(client, 'WettbewerberPreisViewDto', 'Mza.Service.Controllers.V1.Kunden.Models.WettbewerberPreisViewDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
